import React, {useEffect, useState} from "react";
import {Button, Card, CardBody, Col} from "reactstrap";
import {useObservable} from "../../components/utils/observable/observableHook";
import {localeService} from "../../components/utils/observable/services";
import LocalizedStrings from "react-localization";
import {common_strings} from "../../translations/common_translations";
import ErrorModal from "../../components/Alerts/ErrorModal";
import {RotateCircleLoading} from "react-loadingg";
import LoadingOverlay from "react-loading-overlay";
import Label from "reactstrap/es/Label";
import ClassApiService from "../../api/classes-api-service";
import {alert_strings} from "../../translations/alert_translations";

let commonStrings = new LocalizedStrings(common_strings);
let alertStrings = new LocalizedStrings(alert_strings);

const CancellationView = (props) => {

    const locale = useObservable(localeService.locale);

    const [error, setError] = useState(null);
    const [showError, setShowError] = useState(false);
    const [isLoading, setLoading] = useState(false);
    const [message, setMessage] = useState("");
    const [deeplink, setDeeplink] = useState("");

    useEffect(() => {
        checkVerificationRequest()
    }, [])

    function cancelRegistration(cId, bId, uId, sId) {
        setLoading(true);
        ClassApiService.unBookClassForce(cId, bId, uId, sId)
            .then(res => {
                setLoading(false);
                let message = res.return_message
                setDeeplink(res.deeplink)
                if (message) {
                    setMessage(message)
                }
                else setMessage(alertStrings.request_cant_be_processed)
            })
            .catch((e) => {
                setLoading(false);
                handleNetworkError(e)
            });
    }

    function checkVerificationRequest() {
        const qs = require('query-string')
        const parsed = qs.parse(window.location.search);
        const cId = parseInt(parsed.cid);
        const uId = parseInt(parsed.uid);
        const bId = parseInt(parsed.bid);
        const sId = parseInt(parsed.sid);
        const loc = parsed.loc;
        if (loc) {
            onLanguageChanged(loc.substring(0, 2))
        }
        if (cId && uId && bId) {
            cancelRegistration(cId, bId, uId, sId)
        }
    }

    function onLanguageChanged(locale) {
        localeService.setLocale(locale);
    }

    function handleNetworkError(e) {
        setError(e);
        setShowError(true);
        setLoading(false);
    }

    localize();

    function toggleErrorModal() {
        setError(null);
        setShowError(false);
    }

    function openClientApp(e) {
        e.preventDefault()
        window.open(deeplink, "_blank")
    }

    return (
        <>
            {showError &&
            <ErrorModal showError={showError} error={error}
                        toggleErrorModal={toggleErrorModal}/>
            }

            <Col lg="5" md="7" className="mt--50">
                <LoadingOverlay
                    active={isLoading}
                    spinner={<RotateCircleLoading color="white"/>}
                    text=''
                >
                    <Card className="bg-secondary shadow border-0">
                        <CardBody className="px-5 py-5 text-center">

                            <Label>{message}</Label>
                            {deeplink &&
                            <div className="text-center" style={{marginTop: 50}}>
                                <Button className="my-4" color="primary" type="submit"
                                        onClick={e => openClientApp(e)}
                                >
                                    {commonStrings.open.client_app_link}
                                </Button>
                            </div>
                            }
                        </CardBody>
                    </Card>
                </LoadingOverlay>
            </Col>
        </>
    );

    function localize() {
        commonStrings.setLanguage(locale);
        alertStrings.setLanguage(locale);
    }
};

export default CancellationView;
